import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'GOGE',
  description:
    'The most popular AMM on Dogechain! Earn DOGE through yield farming, then stake it in Pools to earn more tokens!',
  image: 'https://goge.dog/images/logo/logotype-square.png',
}

export const getCustomMeta = ( path: string, t: ContextApi['t'] ): PageMeta => {
  switch ( path ) {
    case '/':
      return {
        title: `${ t( 'Home' ) } | ${ t( 'GOGE' ) }`,
      }
    case '/farms':
      return {
        title: `${ t( 'Farms' ) } | ${ t( 'GOGE' ) }`,
      }
    case '/pools':
      return {
        title: `${ t( 'Pools' ) } | ${ t( 'GOGE' ) }`,
      }
    default:
      return null
  }
}
